import { Link } from "react-router-dom";
import type { VideoItem } from "@/types/video";

interface VideoCardProps {
  item: VideoItem;
  showPlayCount?: boolean;
}

export default function VideoCard({ item, showPlayCount = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer animate-fade-up"
      title={`${item.title} - 51无敌电影网`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden rounded-lg bg-secondary-100">
        <img
          src={item.cover}
          alt={`${item.title}封面`}
          title={`${item.title} 最新${item.type === "movie" ? "电影" : "电视剧"}在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/10 to-transparent opacity-90" />

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-label font-semibold leading-5">
          {item.rating.toFixed(1)}
        </span>
        {item.type === "tv" && (
          <span className="absolute top-2 right-2 px-2 py-0.5 rounded-md bg-foreground-950/60 text-background-50 text-xs font-label leading-5 backdrop-blur-sm">
            {item.episodes}集
          </span>
        )}

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="w-12 h-12 rounded-full bg-background-50/90 text-primary-600 flex items-center justify-center">
            <i className="ri-play-fill text-2xl"></i>
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-2.5">
          <div className="flex items-center gap-1.5 text-background-50/90 text-xs font-label">
            <i className="ri-time-line"></i>
            <span>更新至 {item.updatedAt.slice(5)}</span>
            {showPlayCount && (
              <>
                <span className="mx-0.5">·</span>
                <span>{formatCount(item.playCount)}</span>
              </>
            )}
          </div>
        </div>
      </div>

      <h4 className="mt-2.5 text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
        {item.title}
      </h4>
      <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
        {item.year} · {item.region} · {item.genres.slice(0, 2).join(" ")}
      </p>
    </Link>
  );
}

function formatCount(count: number): string {
  if (count >= 100000000) return `${(count / 100000000).toFixed(1)}亿`;
  if (count >= 10000) return `${(count / 10000).toFixed(1)}万`;
  return `${count}`;
}